import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsModalModule, SedsBasicButtonModule, SedsModalAbstractComponent, SedsFlatButtonModule } from 'experian-design-system';

@Component({
    selector: 'pl-user-profile-change-incomplete',
    templateUrl: './user-profile-change-incomplete.component.html',
    styleUrls: ['./user-profile-change-incomplete.component.scss'],
    imports: [CommonModule, SedsModalModule, SedsBasicButtonModule, SedsFlatButtonModule]
})
export class UserProfileChangeIncompleteComponent extends SedsModalAbstractComponent implements OnInit {
    public title: string = '';
    public content: string = '';

    constructor() {
        super();
    }

    override ngOnInit() {
        super.ngOnInit();
        this.title = this.data?.title;
        this.content = this.data?.content;
    }

    public closeModal(): void {
        this.close('cancelled');
    }

    public alterarPerfil(): void {
        this.close('confirmed');
    }
}
